import { ClientItem, mailStore } from 'owa-mail-store';
import { orchestrator } from 'satcheljs';
import getContextualMRUSuggestionsAction from '../actions/getContextualMRUSuggestionsAction';
import storeContextualMRUSuggestionsOnItemAction from '../actions/storeContextualMRUSuggestionsOnItemAction';
import fetchMRUSuggestions from '../services/fetchMRUSuggestions';

export default orchestrator(getContextualMRUSuggestionsAction, async function (actionMessage: {
    referenceItemId: string;
}) {
    const referenceItemId: string = actionMessage.referenceItemId;
    const referenceItem: ClientItem = mailStore.items.get(referenceItemId);

    // fetch again when the attachment button is clicked to refresh the local cache
    if (referenceItem) {
        const contextualAttachmentSuggestions = await fetchMRUSuggestions(referenceItemId);
        storeContextualMRUSuggestionsOnItemAction(
            referenceItemId,
            contextualAttachmentSuggestions.suggestions,
            contextualAttachmentSuggestions.traceId
        );
    }
});
